import { isCancelled, isPaidAndNotPaid } from "utils/helpers"
import {
    useGetHasFutureBookings,
    useGetCanceledBookingsWithPages,
    useGetPastBookingsWithPagination,
} from "modules/ClientAccount/hooks/index"

export function useCard() {
    const { newestPastBooking, isLoading: newestPastBookingLoading } =
        useGetPastBookingsWithPagination()
    const { data: hasFutureBooking, isLoading: hasFutureBookingLoading } = useGetHasFutureBookings()
    const { newestCanceledBooking, isLoading: newestCanceledBookingLoading } =
        useGetCanceledBookingsWithPages()

    const isLastPastBooking =
        newestPastBooking && newestCanceledBooking
            ? newestPastBooking?.session_start_datetime >
              newestCanceledBooking?.session_start_datetime
            : true

    const hasLastPastAndNoFutureBooking =
        newestPastBooking && !hasFutureBooking && isLastPastBooking

    const commonShowSignUpAgainCard = Boolean(
        hasLastPastAndNoFutureBooking && isPaidAndNotPaid(newestPastBooking?.status)
    )

    const isSessionPlanning = commonShowSignUpAgainCard
        ? false
        : (Boolean(newestCanceledBooking) && !hasFutureBooking) ||
          Boolean(hasLastPastAndNoFutureBooking && isCancelled(newestPastBooking?.status))

    const signUpAgainCardPsy = isSessionPlanning
        ? newestCanceledBooking?.psy
        : newestPastBooking?.psy

    const showSignUpAgainCard =
        signUpAgainCardPsy && (commonShowSignUpAgainCard || isSessionPlanning)

    const cardLoading =
        newestPastBookingLoading || hasFutureBookingLoading || newestCanceledBookingLoading

    const showGoToCard = Boolean(!newestPastBooking) && !hasFutureBooking && !newestCanceledBooking

    return {
        showSignUpAgainCard,
        isSessionPlanning,
        signUpAgainCardPsy,
        showGoToCard,
        cardLoading,
    }
}
